import {
    collection,
    getDocs,
    addDoc,
    query,
    orderBy,
    where,
} from 'firebase/firestore';
import { db } from '../database/firebase';

/**
 * Add a new sale record to Firestore
 * @param {Object} saleData
 * @returns {Promise<string>} Document ID
 */
export const addSale = async (saleData) => {
    try {
        const salesRef = collection(db, 'sales');
        const docRef = await addDoc(salesRef, {
            ...saleData,
            createdAt: new Date().toISOString(),
        });
        return docRef.id;
    } catch (error) {
        console.error('Error adding sale:', error);
        throw error;
    }
};

/**
 * Fetch all sales from Firestore, newest first
 * @returns {Promise<Array>}
 */
export const getAllSales = async () => {
    try {
        const salesRef = collection(db, 'sales');
        const q = query(salesRef, orderBy('createdAt', 'desc'));
        const snap = await getDocs(q);
        return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    } catch (error) {
        console.error('Error fetching sales:', error);
        throw error;
    }
};

/**
 * Fetch sales within a date range (ISO date strings "YYYY-MM-DD")
 * @param {string} from
 * @param {string} to
 * @returns {Promise<Array>}
 */
export const getSalesByDateRange = async (from, to) => {
    try {
        const salesRef = collection(db, 'sales');
        const q = query(
            salesRef,
            where('date', '>=', from),
            where('date', '<=', to),
            orderBy('date', 'desc')
        );
        const snap = await getDocs(q);
        return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    } catch (error) {
        console.error('Error fetching sales by date range:', error);
        throw error;
    }
};
